import React, { useContext } from "react";
import { Layout, Card, Checkbox, TextField, Text, BlockStack } from "@shopify/polaris";

// import context
import { PrivateContext } from "lib/context";

const VendorSection = () => {
  const { cms = {} } = useContext(PrivateContext);
  const getTextFields = () => {
    const fields = [
      {
        label: cms("section.contact.label.firstName"),
        placeholder: cms("section.contact.placeHolder.firstName"),
        isRequired: true,
      },
      {
        label: cms("section.contact.label.lastName"),
        placeholder: cms("section.contact.placeHolder.lastName"),
        isRequired: true,
      },
      {
        label: cms("section.contact.label.email"),
        placeholder: cms("section.contact.placeHolder.email"),
        isRequired: true,
      },
      {
        label: cms("section.contact.label.phone"),
        placeholder: cms("section.contact.placeHolder.phone"),
        isRequired: true,
      },
      {
        label: cms("section.contact.label.address"),
        placeholder: cms("section.contact.placeHolder.address"),
        isRequired: true,
      },
      {
        label: cms("section.contact.label.city"),
        placeholder: cms("section.contact.placeHolder.city"),
        isRequired: true,
      },
      {
        label: cms("section.contact.label.postalCode"),
        placeholder: cms("section.contact.placeHolder.postalCode"),
        isRequired: false,
      },
    ];
    return fields.map(({ label, placeholder, isRequired }) => {
      const required = isRequired ? "*" : "";
      return (
        <>
          <TextField label={`${label}${required}`} placeholder={placeholder} value="" disabled />
          <br />
        </>
      );
    });
  };
  const getFields = () => {
    return (
      <>
        <Text as="p">{cms("section.contact.subDescription")}</Text>
        <br />
        {getTextFields()}
        <Checkbox checked={false} label={cms("section.contact.label.autoVerify")} disabled />
      </>
    );
  };
  return (
    <div>
      <Layout.AnnotatedSection title={cms("section.contact.title")} description={cms("section.contact.description")}>
        <Card>
          <Text as="h6" variant="headingSm">
            {cms("section.contact.subTitle")}
          </Text>
          <BlockStack variant="headingLg" as="p">
            {getFields()}
          </BlockStack>
        </Card>
      </Layout.AnnotatedSection>
    </div>
  );
};

export default VendorSection;
